/* eslint camelcase: 0 */

// Nuestra subclase no hereda los generadores del singleton de blockly/javascript, así
// que math_number se declara acá: es el shadow de casi todos los value inputs de los
// toolboxes micro:bit y sin él el perfil no genera código.

export const math_number = (block, generator) => {
  const code = parseFloat(block.getField('NUM').getText());

  return [code, code < 0 ? generator.ORDER_UNARY_NEGATION : generator.ORDER_ATOMIC];
};

export const math_number_minmax_analog = (block, generator) => {
  const code = String(block.getFieldValue('SLIDER')).replace(/"/g, '');

  return [code, generator.ORDER_ATOMIC];
};

export const math_number_minmax = (block, generator) => {
  const code = String(block.getFieldValue('SLIDER')).replace(/"/g, '');

  return [code, generator.ORDER_ATOMIC];
};

export const slider_angle = (block, generator) => [block.getFieldValue('angulo'), generator.ORDER_ATOMIC];

export const math_random = (block, generator) => {
  const min = generator.valueToCode(block, 'NUM', generator.ORDER_NONE);
  const max = generator.valueToCode(block, 'DMAX', generator.ORDER_ATOMIC);

  return [`Math.randomRange(${min}, ${max})\n`, generator.ORDER_ATOMIC];
};

export const math_number_minmax_speed_1023 = (block, generator) => {
  const code = String(block.getFieldValue('SLIDER')).replace(/"/g, '');

  return [code, generator.ORDER_ATOMIC];
};

export const math_arithmetic = (block, generator) => {
  const OPERATORS = {
    ADD: [' + ', generator.ORDER_ADDITION],
    MINUS: [' - ', generator.ORDER_SUBTRACTION],
    MULTIPLY: [' * ', generator.ORDER_MULTIPLICATION],
    DIVIDE: [' / ', generator.ORDER_DIVISION],
    POWER: [null, generator.ORDER_NONE],
  };

  const [operator, order] = OPERATORS[block.getFieldValue('OP')];
  const a = generator.valueToCode(block, 'A', order) || '0';
  const b = generator.valueToCode(block, 'B', order) || '0';

  if (!operator) {
    return [`Math.pow(${a}, ${b})`, generator.ORDER_FUNCTION_CALL];
  }

  return [`${a}${operator}${b}`, order];
};

export const math_number_minmax_matrix8x8 = (block, generator) => {
  const code = String(block.getFieldValue('POSITION')).replace(/"/g, '');

  return [code, generator.ORDER_ATOMIC];
};

export const advanced_map = (block, generator) => {
  const num = generator.valueToCode(block, 'NUM', generator.ORDER_NONE);
  const fromMin = generator.valueToCode(block, 'FROM_MIN', generator.ORDER_NONE);
  const fromMax = generator.valueToCode(block, 'FROM_MAX', generator.ORDER_ATOMIC);
  const toMin = generator.valueToCode(block, 'TO_MIN', generator.ORDER_NONE);
  const toMax = generator.valueToCode(block, 'TO_MAX', generator.ORDER_ATOMIC);

  return [`Math.map(${num}, ${fromMin}, ${fromMax}, ${toMin}, ${toMax})\n`, generator.ORDER_ATOMIC];
};

export const math_modulo = (block, generator) => {
  const dividend = generator.valueToCode(block, 'DIVIDEND', generator.ORDER_MODULUS) || '0';
  const divisor = generator.valueToCode(block, 'DIVISOR', generator.ORDER_MODULUS) || '0';

  return [`${dividend} % ${divisor}`, generator.ORDER_MODULUS];
};

export const math_array = (block, generator) => {
  const values = [0, 1, 2].map((i) => parseFloat(block.getFieldValue(`NUM${i}`)));

  return [`[${values.join(',')}]`, generator.ORDER_ATOMIC];
};
